<template>
  <div class="addJobs">
    <van-nav-bar title="保险上传" left-arrow @click-left="$router.go(-1)" z-index="99999" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-form>
      <van-field placeholder="请输入" class="fieldTextarea" label-width="180" v-model="form.bxxzmc" rows="1" autosize label="保险险种名称（全称）" type="textarea" />
      <van-field style="margin-top: 30px;" placeholder="请输入" class="fieldTextarea" label-width="180" v-model="form.bdh" rows="1" autosize label="保单号" type="textarea" />
      <van-field style="margin-top: 30px;" placeholder="请输入" class="fieldTextarea" label-width="180" v-model="form.bxfczf" rows="1" autosize label="保险费出资方（全称）" type="textarea" />
      <div class="footer_btn">
        <van-button class="btn_submit" type="primary" @click="handleSubmit()">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import iApi from '@/utils/internship'
export default {
  data() {
    return {
      schoolCode:'',
      form: {
        bxxzmc: '',
        bdh: '',
        bxfczf: ''
      },
      currentDate: new Date(),
      sxdwList: [],
      bmList: [],
      sxgwList: [],
      showSxdw: false,
      showBm: false,
      showSxgw: false,
      showKssj: false,
      showJssj: false,
    }
  },
  computed: {
    
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.init();
  },
  methods: {
    async init(){
      const res = await iApi.bxscDetail();
      if(res.code == '1' && res.data != null){
        const data = res.data;
        this.form =data;
      }
    },
    async handleSubmit() {
      const param = {
        bxxzmc: this.form.bxxzmc,
        bdh: this.form.bdh,
        bxfczf: this.form.bxfczf
      }
      const res = await iApi.bxsc(param);
      if(res.code == '1'){
        this.$toast.success('提交成功')
        setTimeout(() => {
          this.init()
        }, 1500);
      }
    }
  },
}
</script>

<style lang="less" scoped>
.addJobs {
  margin-top: -50px;
  padding-bottom: 90px;
  .add_title {
    padding: 14px 0 6px 15px;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .fieldTextarea {
    flex-direction: column;
  }
  .footer_btn {
    width: 100%;
    height: 70px;
    position: fixed;
    bottom: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    box-sizing: border-box;
    .btn_submit {
      width: 100%;
      padding: 12px 65px;
      box-sizing: border-box;
      border-radius: 25px !important;
      background: #0189f9;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      border: 1px solid #e5e5e5;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/bxsc.vue